export const COMPONENT = 'Component';
//# sourceMappingURL=component.js.map